import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import BRAND from "@/brand";

// Vaelger brandets farveramper i index.css. Saettes foer render, saa der ikke
// er et glimt af standardbrandets farver ved indlaesning.
document.documentElement.dataset.brand = BRAND.key;
document.title = BRAND.title;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
